import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, filter, debounceTime } from 'rxjs/operators';
import * as artists from '@webapp/sdk/artists';
import { Actions } from '../../actions';
import { SearchExternalArtists, SearchExternalArtistsSuccess, SearchExternalArtistsError } from '../action-creators';
import { SEARCH_EXTERNAL_ARTISTS } from '../actions';


export const searchExternalArtistsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SearchExternalArtists>(SEARCH_EXTERNAL_ARTISTS),
    filter((action) => action.query.length > 2),
    debounceTime(500),
    mergeMap(async (action) => {
      try {
        const response = await artists.search(action.query);

        return new SearchExternalArtistsSuccess(response);
      } catch (err) {
        return new SearchExternalArtistsError(err.message)
      }
    })
  );